export const transfer = {
    head: 'Coins Transfer',
    title: 'Coins Transfer Detail',
    title2: 'Your coins will be transferred toTipsociety.',
    title3: 'Ratio 1 coin = 10 points',
    confirm_tranfer: 'Coins Transfer Confirmation',
    confirm_desc: 'Do you confirm to transfer coints in total of ',
    text_point: ' points?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    transfer_success: 'Success',
    transfer_success1: 'Successfully transfer points.',
    transfer_success2: 'Please check your Tipsociety points at Tipsociety website',

    contactNumber:{
        name: 'Please fill-in desinated Mobile Number',
        placeholder: 'Please fill-in desinated Mobile Number',
        required: 'Please fill-in desinated Mobile Number',
        too_short: '',
        invalid: '',
    },
    point:{
        name: 'Points to transfer',
        placeholder: 'Insert  Coin',
        required: 'Points to transfer',
        too_short: '',
        invalid: '',
    }
}
